module.exports = __webpack_public_path__ + "img/orStar.eb4c68aa.png";